export default {
	data() {
		return {
			currentURL: "https://www.sterkinekor.com" + ((window.location.path != undefined) ? window.location.path : ''),
			metaTitle: '',
			metaImage: '' || 'https://www.sterkinekor.com/static/img/sk-logo.png',
			metaDescription: '',
			schemaDataSrc: '',
			metaCanonicalURL: "https://www.sterkinekor.com" + ((window.location.path != undefined) ? window.location.path : ''),
		}
	},

	head: {
		title () {
			return {
				inner: this.metaTitle
			}
		},

		meta () {

			return [
				{ name: 'title', content: this.metaTitle },
				{ name: 'description', content: this.metaDescription },
				{ name: 'og:title', content: this.metaTitle },
				{ name: 'og:type', content: 'website' },
				{ name: 'og:url', content: this.currentURL },
				{ name: 'og:image', content: this.metaImage},
				{ name: 'og:description', content: this.metaDescription},
				{ name: 'og:site_name', content: 'Ster-Kinekor'},
			]

		},

		script() {
			return [
				{
					type: 'application/ld+json', inner: JSON.stringify(this.schemaDataSrc)
				}
			]
		},

		link () {
			return [
				{ rel: 'canonical', href: this.metaCanonicalURL },
			]
		}
	},
}


// WEBPACK FOOTER //
// ./src/mixins/meta-data.js